<ui-page-header [showBackButton]="false">
  <ui-icon-button buttonStyle="unthemed" icon="arrow-left" iconStyle="solid" (clicked)="navigateToTicketOverview()"></ui-icon-button>
  Ihr Anliegen
</ui-page-header>

<div class="section-wrapper">
  <ui-srm-create-form location="tickets"></ui-srm-create-form>
</div>
